import { get } from 'lodash';
import sysCmds from './sysCmds';

/**
 * 执行所有指令并返回最后一条结果
 * */
function execute(ast, scopeParams = {}, scopeFunc = {}) {
  if (!ast || Object.prototype.toString.call(ast) !== '[object Array]') {
    throwError();
    return;
  }
  const scope = {
    ...scopeParams,
  };
  scope.__custom_func = scopeFunc;
  const len = ast.length;
  let r = null;
  for (let i = 0; i < len; i++) {
    r = executeACmd.call(scope, ast[i]);
  }
  return r;
}

/**
 * 执行单条指令
 * */
function executeACmd(cmd) {
  const { value: v, type: t, args } = cmd;
  if (t === 'Number' || t === 'Boolean' || t === 'String') {
    return v;
  }
  if (t == 'Func') {
    return executeFunc.call(this, v, args);
  }
  if (t === 'Param') {
    return get(this, v);
  }
  if (t === 'Object') {
    return executeObject.call(this, args);
  }
  if (t === 'Array') {
    return executeArray.call(this, args);
  }
}

/**
 * 执行获取函数结果
 * */
function executeFunc(cmd = '', args = []) {
  const cmds = Object.assign({}, sysCmds, this.__custom_func || {});
  // 针对一些特殊指令做处理
  // SET方法中，设置全局参数（参数长度为2）时，第一个参数可为变量，但不做取值操作，故将其转成字符串
  if (cmd === 'SET' && args.length === 2 && args[0]?.type === 'Param') {
    args[0].type = 'String';
  }
  // IF 和 IFS 需要延迟执行分支，只执行条件为真的分支
  if (cmd === 'IF') {
    const cond = executeACmd.call(this, args[0]);
    if (cond) {
      // 如果真分支参数存在，执行它；否则返回 undefined
      return args.length >= 2 ? executeACmd.call(this, args[1]) : undefined;
    }
    // 如果假分支参数存在，执行它；否则返回 undefined
    return args.length >= 3 ? executeACmd.call(this, args[2]) : undefined;
  }
  if (cmd === 'IFS') {
    const len = args.length;
    // 按顺序检查每个条件，找到第一个为真的条件，执行对应的值
    for (let i = 0; i < len - 1; i += 2) {
      const cond = executeACmd.call(this, args[i]);
      if (cond) {
        return executeACmd.call(this, args[i + 1]);
      }
    }
    // 所有条件都不为真，如果参数数量为奇数（有默认值），执行最后一个参数；否则返回 undefined
    return len % 2 === 1 ? executeACmd.call(this, args[len - 1]) : undefined;
  }
  // 针对数组或对象的方法，参数为回调函数，需包装一层，待cmd方法执行后再执行回调方法。
  if (cmd.startsWith('ARRAY_') || cmd.startsWith('OBJECT_')) {
    const args0 = executeACmd.call(this, args[0]);
    const callbackFn = (item, key) => {
      const callbackFns = args.slice(1);
      const len = callbackFns.length;
      // 使用 Object.create 创建原型链，让子作用域可以访问父作用域的变量
      const newScope = Object.create(this);
      newScope.__item = item;
      newScope.__key = key;
      for (let i = 0; i < len; i++) {
        const r = executeACmd.call(newScope, callbackFns[i]);
        if (i == len - 1) {
          return r;
        }
      }
    };
    return cmds[cmd].apply(this, [args0, callbackFn]);
  }
  const newArgs = executeArray.call(this, args);
  return cmds[cmd].apply(this, newArgs);
}

/**
 * 执行生成对象
 * */
function executeObject(args = []) {
  const obj = {};
  args.forEach((arg) => {
    const { value: v, args } = arg;
    if (args && args[0]) {
      obj[v] = executeACmd.call(this, args[0]);
    }
  });
  return obj;
}

/**
 * 执行生成数组
 * */
function executeArray(args = []) {
  return args.map((arg) => executeACmd.call(this, arg));
}

/**
 * 抛出异常
 * */
function throwError() {
  throw new Error('执行指令错误');
}

export default execute;
